interface ViewSelectorProps {
  activeView: string;
  onViewChange: (view: string) => void;
  options: {
    id: string;
    label: string;
  }[];
}

export default function ViewSelector({ activeView, onViewChange, options }: ViewSelectorProps) {
  return (
    <div className="inline-flex rounded-full shadow-sm overflow-hidden" role="group">
      {options.map(option => (
        <button
          key={option.id}
          type="button"
          className={`px-4 py-2 text-sm font-medium ${
            activeView === option.id 
              ? 'bg-primary text-white' 
              : 'bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600'
          }`}
          onClick={() => onViewChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}